import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Native half of the account menu (layouts/_mobile_profile_button). Stimulus
// only registers this controller when the shell's user agent advertises the
// "account-menu" bridge component (sindi-ios AccountMenuComponent.swift); on
// the web, account_menu_controller.js shows the dropdown instead.
//
// The page sends the avatar's rect plus the items it already renders; the
// shell draws the popover and replies with the index tapped, and that item's
// real link (or the log-out form) is clicked so navigation stays Turbo's.
export default class extends BridgeComponent {
  static component = "account-menu"
  static targets = ["button", "item"]

  open(event) {
    event.preventDefault()
    // Listed first in data-action: stops the web dropdown's toggle as well.
    event.stopImmediatePropagation()

    const rect = this.buttonTarget.getBoundingClientRect()
    const data = this.element.dataset
    const avatarUrl = data.accountMenuAvatarUrlValue
      ? new URL(data.accountMenuAvatarUrlValue, window.location.href).href
      : null

    this.send("display", {
      title: data.accountMenuTitleValue || "",
      subtitle: data.accountMenuSubtitleValue || "",
      avatarUrl,
      initials: data.accountMenuInitialsValue || "",
      color: data.accountMenuColorValue || "#727272",
      anchor: { x: rect.left, y: rect.top, width: rect.width, height: rect.height },
      items: this.itemTargets.map((item, index) => ({
        index,
        title: item.textContent.trim(),
        icon: item.dataset.icon || null,
        destructive: item.dataset.destructive === "true"
      }))
    }, message => {
      const item = this.itemTargets[message.data.selectedIndex]
      if (item) item.click()
    })
  }
}
